import * as React from 'react';
import {useState} from 'react';

import {ContentModal} from '../ui/modals/ContentModal/ContentModal';
import {FilterInput} from '../ui/forms/FilterInput/FilterInput';
import {filterStrings} from '../ui/sort-filter.functions';

interface ShipStateExceptionsModalProps {
    onHide: () => void;
    shipStateExclusions: string[];
    show: boolean;
}

export const ShipStateExceptionsModal = ({onHide, shipStateExclusions, show}: ShipStateExceptionsModalProps) => {
    const [filter, setFilter] = useState(``);

    /**
     * Template
     */
    return (
        <ContentModal
            onClose={onHide}
            show={show}
            title="Shipping Location Exclusions"
        >
            <>
                <FilterInput onInput={(e) => setFilter(e)} />
                <h4 className="tw-mt-4">Product cannot ship to States or Zip Codes below.</h4>
                <table>
                    <tbody>
                        {filterStrings(shipStateExclusions, filter)?.map(
                            (shipStateExclusion) =>
                                shipStateExclusion && (
                                    <tr
                                        className="tw-float-left tw-mr-4"
                                        key={shipStateExclusion}
                                    >
                                        <td>{shipStateExclusion}</td>
                                    </tr>
                                ),
                        )}
                    </tbody>
                </table>
            </>
        </ContentModal>
    );
};
